import CustomTable from "@/shared/components/common/table";
import CustomButton from "@/shared/components/kit/button";
import AlertDialog from "@/shared/components/kit/modal";
import StackKit from "@/shared/components/kit/stack";
import TypoGraphyKit from "@/shared/components/kit/typoGraphy";
import { Grid, TextField, CircularProgress, Box, Skeleton, Alert, ToggleButton, ToggleButtonGroup } from "@mui/material";
import moment from "jalali-moment";
import React, { SetStateAction, useState, useEffect, useMemo } from "react";
import AddUserModal from "./addUserModal";
import { useMutation, useQuery } from "@tanstack/react-query";
import { postAddUser, postIncreaseBalance, postDecreaseBalance } from "@/api/merchant/request.post";
import { toast } from "react-toastify";
import { AxiosError } from "axios";
import { useLocation, useNavigate, useParams } from "react-router";
import AllUserContentModal from "./allUserContentModal";
import PossibilityOfCashingAssetsModal from "./PossibilityOfCashingAssetsModal";
import { toPersianNumber } from "@/hooks/useThousandsSeparator";
import UserCashBalanceModal from "./userCashBalance";
import AddUser from "../userDetail/addUserToCompany";
import { changeClubPazirandeUsers } from '@/api/merchant/request.post'
import { fetchListClubs } from "@/api/merchant/request.get";
import CustomSelectNormal from "@/shared/components/common/select/selectNormal";
import BoxKit from "@/shared/components/kit/box";
// Operation type
type OperationType = 'increase' | 'decrease';

const BodyContent = (props: any) => {
  const { data, setEnabled, refetch, search, onSearchChange, isLoading = false, page, setPage, perPage, onPerPageChange } = props;
  const perPageOptions = [10, 25, 50, 100];
  const { id: paramsId } = useParams();
  const navigate = useNavigate();
  const [selectedOptionAddUser, setSelectedOptionAddUser] = useState<string>("");
  const [selectedClubPazirande, setSelectedClubPazirande] = useState('');
  const [selectedSwitch, setSelectedSwitch] = useState<boolean>(false);
  const [isOpenFormModal, setIsOpenFormModal] = useState(false);
  const [isOpenModalContent, setIsOpenModalContent] = useState(false);
  const [isActiveSwitch, setIsActiveSwitch] = useState(false);
  const [isDeActiveSwitch, setIsDeActiveSwitch] = useState(false);
  const [changeClubPazirande, setChangeClubPazirande] = useState(false);
  const [isOpenModalContentAllUser, setIsOpenModalContentAllUser] = useState(false);
  const [valueUserCharge, setValueUserCharge] = React.useState("1");
  const [success, setSuccess] = useState(false);
  const [balanceAmount, setBalanceAmount] = useState("");
  const [description, setDescription] = useState("");
  const [operationType, setOperationType] = useState<OperationType>('increase');
  const [searchError, setSearchError] = useState<string>("");
  const location = useLocation();
  const path = location.key;
  const [isAddingUser, setIsAddingUser] = useState(false);
  const [isIncreasingBalance, setIsIncreasingBalance] = useState(false);
  const [isDecreasingBalance, setIsDecreasingBalance] = useState(false);

  const [dataForm, setDataForm] = useState({
    NID: "",
    birthday: "",
    club_id: paramsId,
    phoneNumber: "",
  });

  // Add these state variables to BodyContent
  const [selectedUsers, setSelectedUsers] = useState<number[]>([]);
  const [bulkSelected, setBulkSelected] = useState(false);
  const [selectedCardNumbers, setSelectedCardNumbers] = useState<string[]>([]);

  // Create a mapping of user ID to card number for easy lookup
  const userCardMap = useMemo(() => {
    const map: Record<number, string> = {};
    data?.users?.forEach((user: any) => {
      if (user.id && user.card_number) {
        map[user.id] = user.card_number;
      }
    });
    return map;
  }, [data?.users]);

  // Update selected card numbers when selected users change
  useEffect(() => {
    const cardNumbers = selectedUsers
      .map(userId => userCardMap[userId])
      .filter(Boolean);

    setSelectedCardNumbers(cardNumbers);
  }, [selectedUsers, userCardMap]);

  const { mutate: fetchAddUser, isPending: isAddingUserMutation } = useMutation({
    mutationFn: postAddUser,
    onSuccess: () => {
      setEnabled(true);
      setSuccess(true);
      refetch();
      setIsAddingUser(false);
      toast.success("کاربر با موفقیت اضافه شد");
    },
    onError: (error: AxiosError<{ message: string }>) => {
      toast.error(error?.response?.data?.message || "خطا در اضافه کردن کاربر");
      setIsAddingUser(false);
    },
  });

  const { mutate: fetchIncreaseBalance, isPending: isIncreasingBalanceMutation } = useMutation({
    mutationFn: postIncreaseBalance,

    onSuccess: (data: { message?: string }) => {
      setEnabled(true);

      toast.success(data?.message || "موجودی با موفقیت افزایش یافت");

      setSelectedUsers([]);
      setSelectedCardNumbers([]);
      setBalanceAmount("");
      setDescription("");
      setIsIncreasingBalance(false);
      setIsActiveSwitch(false);
    },

    onError: (error: AxiosError<{ message: string }>) => {
      toast.error(error?.response?.data?.message || "خطا در افزایش موجودی");
      setIsIncreasingBalance(false);
    },
  });


  const { mutate: fetchDecreaseBalance, isPending: isDecreasingBalanceMutation } = useMutation({
    mutationFn: postDecreaseBalance,
    onSuccess: () => {
      setEnabled(true);
      toast.success("موجودی با موفقیت کاهش یافت");
      // Clear selection after successful operation
      setSelectedUsers([]);
      setSelectedCardNumbers([]);
      setBalanceAmount("");
      setDescription("");
      setIsDecreasingBalance(false);
      // Close the modal
      setIsActiveSwitch(false);
    },
    onError: (error: AxiosError<{ message: string }>) => {
      toast.error(error?.response?.data?.message || "خطا در کاهش موجودی");
      setIsDecreasingBalance(false);
    },
  });

  const { data: dataListClubs, isFetched, isLoading: loadingListClubs } = useQuery({
    queryKey: ["listClubs-data", path],
    queryFn: fetchListClubs,

  })

  const { mutate: fetchChangeClubPazirandeUsers, isPending: isChangeClubPazirandeUsers } = useMutation({
    mutationFn: changeClubPazirandeUsers,
    onSuccess: () => {
      toast.success("عملیات با موفقیت افزایش یافت");
      refetch();
      setSelectedUsers([]);
      setSelectedClubPazirande('');
      setChangeClubPazirande(false);
    },
    onError: (error: AxiosError<{ message: string }>) => {
      toast.error(error?.response?.data?.message || "خطا در انجام عملیات");
      setChangeClubPazirande(false);
    },
  });

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;

    // Validate search length
    if (value.trim().length > 0 && value.trim().length < 3) {
      setSearchError("حداقل ۳ کاراکتر برای جستجو وارد کنید");
    } else {
      setSearchError("");
    }
    onSearchChange(value);

  };

  const handleClearSearch = () => {
    onSearchChange("");
    setSearchError("");
  };

  const handleSubmit = () => {
    if (!success) {
      setIsAddingUser(true);
      const requestBody = {
        ...dataForm,
        birthday: dataForm?.birthday ? moment(dataForm.birthday).locale("fa").format("YYYY/MM/DD") : null
      };
      fetchAddUser(requestBody);
    } else {
      setIsOpenFormModal(false);
    }
  };

  const handleSubmitCashModal = () => {
    if (selectedCardNumbers.length === 0) {
      toast.error("لطفا حداقل یک کاربر را انتخاب کنید");
      return;
    }

    if (!balanceAmount || parseFloat(balanceAmount) <= 0) {
      toast.error("لطفا مبلغ معتبر وارد کنید");
      return;
    }

    const requestBody = {
      club_id: paramsId,
      description: description,
      price: balanceAmount,
      card_number: selectedCardNumbers
    };

    if (operationType === 'increase') {
      setIsIncreasingBalance(true);
      fetchIncreaseBalance(requestBody);
    } else {
      setIsDecreasingBalance(true);
      fetchDecreaseBalance(requestBody);
    }
  };

  const handleSubmitPossibleModal = () => {
    if (selectedCardNumbers.length === 0) {
      toast.error("لطفا حداقل یک کاربر را انتخاب کنید");
      return;
    }

    if (!balanceAmount || parseFloat(balanceAmount) <= 0) {
      toast.error("لطفا مبلغ معتبر وارد کنید");
      return;
    }

    setIsIncreasingBalance(true);
    const requestBody = {
      club_id: paramsId,
      description: description,
      price: balanceAmount,
      card_number: selectedCardNumbers
    };

    fetchIncreaseBalance(requestBody);
  };

  const dataHeader = [
    { id: "row_number", title: "ردیف" },
    { id: "full_name", title: "نام و نام خانوادگی" },
    { id: "card_number", title: "شماره کارت" },
    { id: "created_at", title: "تاریخ ثبت کاربر" },
    { id: "moreElement", title: "" },
  ];
  const handleClickDetails = (id: number) => {
    navigate(`/customer-my-organization/user-details/${id}?page=${page}&club=${paramsId}`);
  };

  const newData = data?.users?.map((item: any, index: number) => {
    const perPage = data?.per_page || 10;
    const rowNumber = (page - 1) * perPage + index + 1;

    return {
      ...item,
      row_number: toPersianNumber((index + 1).toString()),
      id: item.id,
      card_number: toPersianNumber(item?.card_number),
      original_card_number: item?.card_number,
      created_at: toPersianNumber(moment(item.created_at).locale("fa").format("jYYYY/jMM/jDD")),
      moreElement: (
        <StackKit direction={"row"} gap={2}>
          <CustomButton onClick={() => handleClickDetails(item.id)}>
            <TypoGraphyKit variant="body1">مشاهده جزئیات بیشتر</TypoGraphyKit>
          </CustomButton>
        </StackKit>
      ),
    };
  }) || [];

  const handleClickOpenOtherModal = () => {
    if (selectedOptionAddUser === "option1") {
      setIsOpenFormModal(true);
      setIsOpenModalContent(false);
      setSuccess(false);
    }
  };

  const handleClickOpenAllUser = () => {
    setIsActiveSwitch(!!selectedSwitch);
    setIsDeActiveSwitch(!selectedSwitch);
    setIsOpenModalContentAllUser(false);
  };

  const handleSelectionChange = (selectedIds: number[]) => {
    setSelectedUsers(selectedIds);
  };

  const handleBulkSelectionChange = (isSelected: boolean) => {
    setBulkSelected(isSelected);
  };

  const handleClearSelection = () => {
    setSelectedUsers([]);
    setSelectedCardNumbers([]);
    toast.info("انتخاب کاربران لغو شد");
  };

  const handleFile = (file: any) => { };

  const hanleChangeClubPazirandeUsers = () => {
    const requestBody = {
      userIds: selectedUsers,
      fromClubId: Number(paramsId),
      toClubId: selectedClubPazirande,
    };
    fetchChangeClubPazirandeUsers(requestBody);
  }

  const handlePerPageChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const newPerPage = Number(event.target.value);
    onPerPageChange(newPerPage); // Call the parent's handler
  };
  // Loading skeleton for table rows
  const renderSkeletonRows = () => {
    return Array.from({ length: 5 }).map((_, index) => (
      <tr key={index}>
        {dataHeader.map((header, idx) => (
          <td key={idx} style={{ padding: '16px' }}>
            <Skeleton variant="text" width="100%" height={30} />
          </td>
        ))}
      </tr>
    ));
  };

  const getAgreeButtonText = () => {
    if (operationType === 'increase') {
      return isIncreasingBalanceMutation ? "در حال افزایش..." : "افزایش موجودی";
    } else {
      return isDecreasingBalanceMutation ? "در حال کاهش..." : "کاهش موجودی";
    }
  };

  const getModalTitle = () => {
    return operationType === 'increase' ? "افزایش موجودی نقدی کاربر" : "کاهش موجودی نقدی کاربر";
  };

  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12 }}>
        <StackKit direction={{ xs: "column", sm: "row" }} justifyContent={"space-between"} alignItems={{ xs: "stretch", sm: "center" }} gap={2}>
          <StackKit direction={{ xs: "column", sm: "row" }} alignItems={{ xs: "stretch", sm: "center" }} gap={2} sx={{ width: { xs: "100%", sm: "70%" } }}>
            <TypoGraphyKit variant="body1">تعداد</TypoGraphyKit>
            <CustomButton fullWidth={true} onClick={() => setIsOpenModalContent(true)} disabled={isAddingUserMutation}>
              {isAddingUserMutation ? (
                <CircularProgress size={20} color="inherit" />
              ) : (
                <TypoGraphyKit variant="body1">افزودن کاربر</TypoGraphyKit>
              )}
            </CustomButton>
            <CustomButton fullWidth={true} onClick={() => setIsOpenModalContentAllUser(true)} disabled={isIncreasingBalanceMutation || isDecreasingBalanceMutation}>
              {(isIncreasingBalanceMutation || isDecreasingBalanceMutation) ? (
                <CircularProgress size={20} color="inherit" />
              ) : (
                <TypoGraphyKit variant="body1">
                  فرم اعتبار کاربر
                </TypoGraphyKit>
              )}
            </CustomButton>
          </StackKit>

          {/* Search and Per Page Section */}
          <StackKit direction={{ xs: "column", sm: "row" }} alignItems={{ xs: "stretch", sm: "center" }} gap={2} sx={{ width: { xs: "100%", sm: "30%" } }}>
            <TextField
              type="search"
              variant="outlined"
              fullWidth
              placeholder="جستجو (نام، شماره کارت، ...)"
              value={search}
              onChange={handleSearchChange}
              error={!!searchError}
              helperText={searchError}
              InputProps={{
                endAdornment: isLoading && (<CircularProgress size={20} sx={{ ml: 1 }} />)
              }}
              sx={{ input: { padding: "12px", boxSizing: "border-box", ":placeholder-shown": { color: "#666666" } } }}
            />

            {/* Per Page Selector */}
          </StackKit>
        </StackKit>
        <StackKit direction="row" alignItems="center" gap={1} justifyContent={'flex-end'} marginTop={2}>
          <TypoGraphyKit variant="body2" sx={{ whiteSpace: 'nowrap' }}>
            تعداد در هر صفحه:
          </TypoGraphyKit>
          <select
            value={perPage || 10}
            onChange={handlePerPageChange}
            style={{
              padding: '8px 12px',
              borderRadius: '4px',
              border: '1px solid #ccc',
              backgroundColor: '#323232',
              cursor: 'pointer',
              fontSize: '14px'
            }}
          >
            {perPageOptions.map(option => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
        </StackKit>
      </Grid>

      {/* Loading indicator for initial load */}
      {isLoading && newData.length === 0 && (
        <Grid size={{ xs: 12 }}>
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 200 }}>
            <CircularProgress />
          </Box>
        </Grid>
      )}

      {/* Selection Info - Show skeleton when loading */}
      <Grid size={{ xs: 12 }}>
        {isLoading ? (
          <Skeleton variant="rectangular" height={60} sx={{ mb: 2, borderRadius: 1 }} />
        ) : selectedUsers.length > 0 && (
          <StackKit direction="row" justifyContent="space-between" alignItems="center" spacing={2} sx={{ mb: 2, p: 2, bgcolor: 'rgba(25, 118, 210, 0.1)', borderRadius: 1 }}>
            <TypoGraphyKit variant="body1">
              {toPersianNumber(selectedUsers.length)} کاربر ({toPersianNumber(selectedCardNumbers.length)} کارت) انتخاب شده است
            </TypoGraphyKit>
            <StackKit direction="row" gap={2} spacing={1}>
              <CustomButton
                size="small"
                variant="outlined"
                onClick={handleClearSelection}
                disabled={isLoading}
              >
                <TypoGraphyKit variant="body2">لغو انتخاب</TypoGraphyKit>
              </CustomButton>
              {selectedCardNumbers.length > 0 && (
                <CustomButton size="small" variant="outlined" disabled={isLoading} onClick={() => { toast.info(`شماره کارت‌های انتخاب شده: ${selectedCardNumbers.join(', ')}`); }}>
                  <TypoGraphyKit variant="body2">نمایش کارت‌ها</TypoGraphyKit>
                </CustomButton>
              )}
            </StackKit>
          </StackKit>
        )}
      </Grid>

      {/* Table */}
      <Grid sx={{ overflowX: 'auto' }} size={{ xs: 12 }}>
        {isLoading ? (
          <Box sx={{ minHeight: 300, display: 'flex', flexDirection: 'column' }}>
            {/* Skeleton for table header */}
            <Box sx={{ display: 'flex', mb: 2 }}>
              {dataHeader.map((header, index) => (
                <Skeleton key={index} variant="text" width={`${100 / dataHeader.length}%`} height={40} sx={{ mx: 1 }} />
              ))}
            </Box>
            {/* Skeleton for table rows */}
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <tbody>
                {renderSkeletonRows()}
              </tbody>
            </table>
          </Box>
        ) : (
          <>
            {search.trim().length >= 3 && data?.users?.length === 0 ? (
              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: 300, p: 3 }}>
                <TypoGraphyKit variant="h6" sx={{ mb: 2 }}>
                  نتیجه‌ای برای جستجوی "{search}" یافت نشد
                </TypoGraphyKit>
                <CustomButton sx={{ color: '#fff' }} variant="outlined" onClick={handleClearSearch}>
                  پاک کردن جستجو
                </CustomButton>
              </Box>
            ) : (
              <CustomTable
                currentPage={page}
                total={data?.total || 0}
                setPages={setPage}
                itemsPerPage={data?.per_page || 10}
                dataHeader={dataHeader}
                dataTbody={newData}
                colorPagination={"#fff"}
                selectable={true}
                selectedRows={selectedUsers}
                onSelectionChange={handleSelectionChange}
                bulkSelection={bulkSelected}
                onBulkSelectionChange={handleBulkSelectionChange}
              />
            )}
          </>
        )}
      </Grid>

      {/* Modals */}
      <AlertDialog open={isOpenModalContent} disagreeText="بستن" onClose={() => setIsOpenModalContent(false)} isHeader header={<TypoGraphyKit variant="h6">افزودن کاربر</TypoGraphyKit>} agreeText="ادامه" onAgree={handleClickOpenOtherModal}>
        <AddUser selectedOption={selectedOptionAddUser} setSelectedOption={setSelectedOptionAddUser} />
      </AlertDialog>

      <AlertDialog
        open={isOpenFormModal}
        disagreeText="بستن"
        onClose={() => setIsOpenFormModal(false)}
        isHeader
        header={<TypoGraphyKit variant="h6">افزودن کاربر</TypoGraphyKit>}
        agreeText={success ? "بستن" : (isAddingUserMutation ? "در حال افزودن..." : "ادامه")}
        onAgree={handleSubmit}
      >
        <AddUserModal setDataForm={setDataForm} dataForm={dataForm} success={success} />
      </AlertDialog>

      <AlertDialog
        open={isOpenModalContentAllUser}
        disagreeText="بستن"
        onClose={() => setIsOpenModalContentAllUser(false)}
        isHeader
        header={<TypoGraphyKit variant="h6">افزایش اعتبار نقدی داخلی/شارژ نقدی</TypoGraphyKit>}
        agreeText="ادامه"
        onAgree={handleClickOpenAllUser}
      >
        <AllUserContentModal setSelectedSwitch={setSelectedSwitch} selectedSwitch={selectedSwitch} countUser={newData?.length} />
      </AlertDialog>

      {/* Updated modal for cash balance with increase/decrease toggle */}
      <AlertDialog
        open={isActiveSwitch}
        disagreeText="بستن"
        onClose={() => {
          setIsActiveSwitch(false);
          setSelectedUsers([]);
          setBalanceAmount("");
          setDescription("");
          setOperationType('increase');
        }}
        isHeader
        header={
          <StackKit direction="column" gap={2}>
            <StackKit direction="row" justifyContent="space-between" alignItems="center">
              <TypoGraphyKit variant="h6">{getModalTitle()}</TypoGraphyKit>
              {selectedCardNumbers.length > 0 && (
                <TypoGraphyKit variant="caption" sx={{ color: 'primary.main' }}>
                  {toPersianNumber(selectedCardNumbers.length)} کارت انتخاب شده
                </TypoGraphyKit>
              )}
            </StackKit>
          </StackKit>
        }
        agreeText={getAgreeButtonText()}
        onAgree={handleSubmitCashModal}
        onDisagree={() => {
          setIsActiveSwitch(false);
          setSelectedUsers([]);
          setBalanceAmount("");
          setDescription("");
          setOperationType('increase');
        }}
        disabled={isIncreasingBalanceMutation || isDecreasingBalanceMutation}
      >
        <UserCashBalanceModal
          setDescription={setDescription}
          setBalanceAmount={setBalanceAmount}
          description={description}
          balanceAmount={balanceAmount}
          setOperationType={setOperationType}
          operationType={operationType}
        />
      </AlertDialog>

      <AlertDialog
        open={isDeActiveSwitch}
        disagreeText="بستن"
        onClose={() => {
          setIsDeActiveSwitch(false);
          setSelectedUsers([]);
          setBalanceAmount("");
          setDescription("");
        }}
        isHeader
        header={
          <StackKit direction="row" justifyContent="space-between" alignItems="center">
            <TypoGraphyKit variant="h6">افزایش اعتبار داخلی (هدیه)</TypoGraphyKit>
            {selectedCardNumbers.length > 0 && (
              <TypoGraphyKit variant="caption" sx={{ color: 'primary.main' }}>
                {toPersianNumber(selectedCardNumbers.length)} کارت انتخاب شده
              </TypoGraphyKit>
            )}
          </StackKit>
        }
        agreeText={isIncreasingBalanceMutation ? "در حال افزایش..." : "افزایش اعتبار"}
        onAgree={handleSubmitPossibleModal}
        disabled={isIncreasingBalanceMutation}
      >
        <PossibilityOfCashingAssetsModal
          setDescription={setDescription}
          setBalanceAmount={setBalanceAmount}
          description={description}
          balanceAmount={balanceAmount}
          setValueUserCharge={setValueUserCharge}
          valueUserCharge={valueUserCharge}
        />
      </AlertDialog>

      <AlertDialog
        open={changeClubPazirande}
        disagreeText="بستن"
        onClose={() => { setChangeClubPazirande(false); }}
        isHeader
        header={
          <StackKit direction="row" justifyContent="space-between" alignItems="center">
            <TypoGraphyKit variant="h6">جابه‌جایی کاربر به سازمان</TypoGraphyKit>
          </StackKit>
        }
        agreeText={isIncreasingBalanceMutation ? "در حال بارگذاری..." : "جابه‌جایی کاربر"}
        onAgree={hanleChangeClubPazirandeUsers}
        disabled={isChangeClubPazirandeUsers}
      >
        <StackKit direction={'column'} sx={{ width: "100%", height: '100%' }} justifyContent={"center"} alignItems={'center'}>
          <BoxKit sx={{ width: '100%', textAlign: "right" }}>
            <TypoGraphyKit variant="body1" marginBottom={'10px'}>
              سازمان مورد نظر خود را انتخاب کنید
            </TypoGraphyKit>
          </BoxKit>
          <CustomSelectNormal
            className="text-right justify-end"
            label=""
            value={selectedClubPazirande}
            onChange={(e) => {
              const selectedId = e.target.value;
              const selectedItem = dataListClubs?.find(
                (item: any) => item.id === selectedId
              );
              setSelectedClubPazirande(selectedId);
            }}
            options={dataListClubs ?? []}
            getOptionLabel={(item) => `${item.title}`}
            getOptionValue={(item) => item.id}
            width={'100%'}
          />
        </StackKit>
      </AlertDialog>

      {/* Bottom Buttons */}
      {!isLoading && (
        <StackKit direction={{ xs: "column", sm: "row" }} justifyContent={"space-between"} gap={2} sx={{ width: "100%" }}>
          <CustomButton
            fullWidth={true}
            onClick={() => {
              if (selectedUsers.length === 0) {
                toast.error("لطفا ابتدا کاربران مورد نظر را انتخاب کنید");
                return;
              }
              setIsActiveSwitch(true);
            }}
            disabled={selectedUsers.length === 0 || isIncreasingBalanceMutation || isDecreasingBalanceMutation}
          >
            {(isIncreasingBalanceMutation || isDecreasingBalanceMutation) ? (
              <CircularProgress size={20} color="inherit" />
            ) : (
              <TypoGraphyKit variant="body1">
                افزایش / کاهش موجودی نقدی سازمانی
                {selectedUsers.length > 0 && ` (${selectedUsers.length} کاربر)`}
              </TypoGraphyKit>
            )}
          </CustomButton>
          <CustomButton
            fullWidth={true}
            onClick={() => {
              if (selectedUsers.length === 0) {
                toast.error("لطفا ابتدا کاربران مورد نظر را انتخاب کنید");
                return;
              }
              setIsDeActiveSwitch(true);
            }}
            disabled={selectedUsers.length === 0 || isIncreasingBalanceMutation || isDecreasingBalanceMutation}
          >
            {(isIncreasingBalanceMutation || isDecreasingBalanceMutation) ? (
              <CircularProgress size={20} color="inherit" />
            ) : (
              <TypoGraphyKit variant="body1">
                افزایش / کاهش موجودی اعتباری سازمانی
                {selectedUsers.length > 0 && ` (${selectedUsers.length} کاربر)`}
              </TypoGraphyKit>
            )}
          </CustomButton>
          <CustomButton
            fullWidth={true}
            onClick={() => {
              if (selectedUsers.length === 0) {
                toast.error("لطفا ابتدا کاربران مورد نظر را انتخاب کنید");
                return;
              }
              setChangeClubPazirande(true);
            }}
            disabled={selectedUsers.length === 0 || isIncreasingBalanceMutation || isDecreasingBalanceMutation}
          >
            {(isIncreasingBalanceMutation || isDecreasingBalanceMutation) ? (
              <CircularProgress size={20} color="inherit" />
            ) : (
              <TypoGraphyKit variant="body1">
                جابه‌جایی کاربر به سازمان دیگر
                {selectedUsers.length > 0 && ` (${selectedUsers.length} کاربر)`}
              </TypoGraphyKit>
            )}
          </CustomButton>
        </StackKit>
      )}
    </Grid>
  );
};

export default BodyContent;